export default __webpack_public_path__ + "static/fire_protection_w.6beee7892654aae61ba7b66e272edf83.png";